// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SystemDocument } from '@interfaces/document.interfaces';
import { AppEvent } from '@interfaces/interfaces';
import { ModalSize } from '@interfaces/shared.interfaces';

import { SharedService } from '@services/shared.service';

@Component({
    selector: 'system-document-modal',
    templateUrl: './system-document-modal.component.html',
    styleUrls: ['./system-document-modal.component.scss'],
})
export class SystemDocumentModalComponent implements OnInit {
    // we use this to display HTML of a SystemDocument or SystemMessage
    doc: any;
    docList: any[] = [];
    public pdfToRender: any;
    public pdfUrl: string;
    public pdfLoading = false;
    public viewerHeight: number;
    public viewerWidth: number;

    constructor(
        private dialogRef: MatDialogRef<SystemDocumentModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private readonly sharedService: SharedService
    ) {
        this.viewerHeight = this.data?.modalSize
            ? this.sharedService.getModalInnerContentHeight(this.data?.modalSize)
            : this.sharedService.getModalInnerContentHeight(ModalSize.Medium);
        this.viewerWidth = this.data?.modalSize
            ? this.sharedService.getModalInnerContentWidth(this.data?.modalSize)
            : this.sharedService.getModalInnerContentWidth(ModalSize.Medium);

        this.doc = data.doc;
        this.pdfToRender = this.doc.pdfUrl;
        if (this.doc && this.doc.pdfUrl) {
            this.pdfToRender = data.doc.pdfUrl;
            this.pdfLoading = true;
        }

        // for release notes we are getting an array of docs
        if (this.doc?.length) {
            // select the most recent release note
            this.doc = this.doc[0];
            // the list is what we display in mat-select
            this.docList = data.doc;
        }
    }

    async ngOnInit(): Promise<void> {
        if (this.doc.messageHTML || this.doc.htmlDoc) {
            const appended = document.getElementsByClassName('doc-container');
            const parser = new DOMParser();
            const html = this.doc?.htmlDoc ? this.doc.htmlDoc : this.doc.messageHTML;
            const docHTML = parser.parseFromString(html, 'text/html');
            appended[0].appendChild(docHTML.body);
        }
    }

    onProgress(event: any) {
        if (event.loaded === event.total) {
            this.pdfLoading = false;
        }
    }

    public eventHandler(event: AppEvent): void {}

    public closeModal() {
        this.dialogRef.close();
    }

    public displayHtml(doc: SystemDocument): void {
        const appended = document.getElementsByClassName('doc-container');
        // remove the previously added element
        appended[0].firstChild.remove();
        const parser = new DOMParser();
        const docHTML = parser.parseFromString(doc.htmlDoc, 'text/html');
        // can't append document nodes, so we take the child of the document object
        appended[0].appendChild(docHTML.documentElement);
    }
}
